import Header from "@/components/header";
import {
  Badge,
  Center,
  Container,
  Group,
  Loader,
  LoadingOverlay,
  Stack,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { useEffect, useState } from "react";

import TransactionItem from "@/modules/profile/transactionItem";
import { useInView } from "react-intersection-observer";
import { IconClipboardOff } from "@tabler/icons-react";
import useGetTransactions from "../hooks/useGetTransactions";

function Transactions() {
  const [activePage, setPage] = useState(0);
  const { ref, inView } = useInView({ threshold: 0.4 });
  const { data, isLoading, hasNextPage, fetchNextPage } = useGetTransactions({
    params: {
      Count: 10,
      Skip: activePage * 10,
    },
  });

  const theme = useMantineTheme();

  useEffect(() => {
    fetchNextPage();
  }, [activePage]);

  useEffect(() => {
    if (inView) setPage((prev) => prev + 1);
  }, [inView]);

  return (
    <>
      <Header title="تراکنش ها" showBack route="/dashboard/profile" />
      <Container w="100%" size="full">
        <Title order={4}> تراکنش ها </Title>
      </Container>
      <Stack mt="md">
        <LoadingOverlay visible={isLoading} />
        <Stack px="md">
          {data?.pages?.length !== 0 ? (
            <Group>
              <Badge variant="dot" color="blue" size="lg" radius="xl">
                تعداد کل : {data?.pages[0]?.count}
              </Badge>
            </Group>
          ) : null}

          {data?.pages?.map((page) =>
            page?.result?.map((item) => (
              <TransactionItem key={item.id} transaction={item} />
            ))
          )}

          {data?.pages[0]?.result?.length === 0 ? (
            <Stack align="center" justify="center" mt="lg">
              <IconClipboardOff size={50} color={theme?.colors.gray[2]} />
              <Text
                style={{
                  color: theme?.colors.gray[4],
                }}
                size="sm"
              >
                موردی برای نمایش موجود نیست
              </Text>
            </Stack>
          ) : null}

          {!isLoading && hasNextPage && (
            <div ref={ref}>
              <Center>
                <Loader type="dots" />
              </Center>
            </div>
          )}
        </Stack>
      </Stack>
    </>
  );
}

export default Transactions;
